<template>
    <rkm-modal
        large
        ref="Modal"
        title="Protocolo OCI"
    >
        <rkm-form
            v-if="model"
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-select
                        :options="form.ocis"
                        :validations="validations.oci"
                        label="OCI"
                        show-default-option
                        text-field="nome"
                        v-model="model.ociId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Vuex.
import { mapActions, mapGetters } from 'vuex'

// Mixins.
import { repository, error } from '@/mixins'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        validations() {

            return {
                oci: { required: true }
            }
        },
    },
    created() {

        this.repositories = {
            fila: this.getConectaSusRepository('regulacao.fila')
        }
    },
    data: () => ({
        solicitacao: null,
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(solicitacao) {

            this.solicitacao = solicitacao

            this.resetForm()
            this.load()

            this.$refs.Modal.show()
        },
        load() {

            this.setLoading()

            this.repositories.fila.createOci(this.solicitacao.id)
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        resetForm() {

            this.form = null
            this.model = null
        },
        save() {

            this.$refs.Form.validate().then(valid => {

                if (!valid) return

                this.setLoading()

                this.repositories.fila.storeOci(this.solicitacao.id, { oci_id: this.model.ociId })
                    .then(() => {

                        this.showSaveNotification()
                        this.$emit('save')

                        this.$refs.Modal.hide()
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            })
        },
    },
    mixins: [repository, error],
}
</script>